import { Store } from 'utils';

class IndexStore extends Store {

    getInitialState() {
        return {
            index: [],
            error: false
        }
    }

    onIndexChanged(state, data) {
        state.index = data;
        state.error = false;
    }

    onError(state) {
        state.error = true;
    }

}

const store = new IndexStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/IndexStore.js